<template>
  <v-menu
    v-model="showUserSelectionMenu"
    bottom
    :close-on-content-click="false"
    min-width="auto"
    offset-y
    left
    transition="scale-transition"
  >
    <template #activator="{ attrs, on }">
      <slot
        name="activator"
        v-bind="{ attrs, on }"
      />
    </template>

    <v-card>
      <v-text-field
        v-model="searchInput"
        class="pa-2 pb-0"
        clearable
        dense
        :disabled="isLoading"
        hide-details
        outlined
      />
      <v-list
        class="overflow-y-auto"
        dense
        :disabled="isLoading"
        max-height="40vh"
      >
        <v-list-item-group
          v-model="selectedUsers"
          :multiple="multiple"
        >
          <v-list-item
            v-for="item of filteredUsers"
            v-show="!item.hidden"
            :key="item.value"
            :value="item.value"
          >
            <template #default="{ active }">
              <v-list-item-action
                v-if="multiple"
              >
                <v-checkbox
                  :input-value="active"
                />
              </v-list-item-action>
              <UserSelectListItem :user="item" />
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import UserSelectListItem from './UserSelectListItem.vue'

export default {
  name: 'UserSelectDropdown',
  components: { UserSelectListItem },
  inheritAttrs: false,

  model: {
    prop: 'users',
    event: 'change',
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    open: {
      type: Boolean,
      default: false,
    },

    userList: {
      type: Array,
      required: true,
    },

    users: {
      type: [Array, Number],
      default: null,
    },
  },

  data () {
    return {
      lazyIsOpen: false,
      lazyUsers: undefined,
      searchInput: '',
    }
  },

  computed: {
    colorForUserListButtonBadge () {
      return this.selectedUsers.length ? 'primary' : 'red'
    },

    filteredUsers () {
      const searchText = (this.searchInput || '').trim().toLowerCase()

      return this.userList.map(u => {
        return {
          ...u,
          hidden: searchText && u.text.toLowerCase().indexOf(searchText) < 0,
        }
      })
    },

    isLoading () { return this.loading },

    selectedUsers: {
      get () { return this.lazyUsers || [] },

      set (value) {
        this.lazyUsers = value
        this.$emit('change', value)
        if (!this.multiple) this.showUserSelectionMenu = false
      },
    },

    showUserSelectionMenu: {
      get () { return this.lazyIsOpen },

      set (value) {
        this.lazyIsOpen = value
        this.$emit('update:open', value)
        if (this.lazyIsOpen) this.searchInput = ''
      },
    },
  },

  watch: {
    open (value) {
      this.lazyIsOpen = value
    },

    users (value) {
      this.lazyUsers = value || []
    },
  },

  created () {
    this.lazyIsOpen = this.open
    this.lazyUsers = this.users || []
  },

  methods: {
  },
}
</script>

<style scoped>
.user-selection-menu-badge {
  .v-badge__badge {
    font-size: 11px;
    padding: 2px;
    height: 14px;
    min-width: 14px;
  }
}
</style>
